import { CasProfileApi } from "@jti/rest-api";
import { type IUser } from "@jti/rest-api-types";

export const checkAgeVerified = async (user: IUser): Promise<boolean> => {
  if (!user?.ciam_token) {
    return false;
  }

  try {
    const { is_age_verified } = await CasProfileApi.init().getProfile();
    return is_age_verified;
  } catch (e) {
    console.error("checkAgeVerified error ==>", e);
    return false;
  }
};
